module.exports = __webpack_public_path__ + "static/media/Mapfre.6c379877.webp";